import Service from "../Service";

const resource = "SupplyingOfLots/"

export default {
    save(SppID, requestID) {
        console.log("save", SppID);
        return Service.post(resource + "save", {}, {
            params: { SppID: SppID, requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    }

};